import { LocationOption } from '@/components/content/Header/parts/DeliveryLocator/parts/LocationOption/LocationOption';
import {
	addAddressBtnSX,
	addAddressMsgSX,
	addAddressTriggerIconSX,
	addAddressTriggerSX,
	savedAddressContainerSX,
	savedAddressDividerSX,
	savedAddressOptionsContainerSX,
} from '@/components/content/Header/parts/DeliveryLocator/styles/SavedAddresses/savedAddressesStyles';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { EMPTY_STRING } from '@/data/constants/marketing';
import { useLocalization } from '@/data/Localization';
import { Address } from '@/data/types/Address';
import { makeEditable } from '@/utils/address';
import { Box, Button, Divider, Link, Stack, Typography } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

type Props = {
	addressList: Address[];
	selectedAddress?: Address;
	handleOnEditAddress: (address: Address) => void;
	handleOpenAddAddressDrawer: () => void;
	handleCloseDeliveryPanel: () => void;
};

export const SavedAddresses = ({
	addressList,
	selectedAddress,
	handleOnEditAddress,
	handleOpenAddAddressDrawer,
	handleCloseDeliveryPanel,
}: Props) => {
	const localization = useLocalization('DeliveryLocator');
	const haveAddress = addressList?.[0]
		? makeEditable(addressList[0])?.addressLine1 !== EMPTY_STRING
		: false;
	const selectedAddressId = selectedAddress ? selectedAddress.addressId : '';

	return (
		<Stack sx={savedAddressContainerSX}>
			{haveAddress ? (
				<>
					<Link sx={addAddressTriggerSX} onClick={handleOpenAddAddressDrawer}>
						<DynamicIcon
							sx={addAddressTriggerIconSX}
							name={MATERIAL_SYMBOL_ICONS.add}
							size="24px"
						/>
						<Typography variant="button">{localization.addNewAddress.t()}</Typography>
					</Link>
					<Divider />
					<Box sx={savedAddressOptionsContainerSX}>
						{addressList.map((address) => {
							const isSelectedAddress = address.addressId === selectedAddressId;
							return isSelectedAddress ? null : (
								<>
									<LocationOption
										key={address.addressId}
										address={address}
										handleOnEditAddress={handleOnEditAddress}
										handleCloseDeliveryPanel={handleCloseDeliveryPanel}
									></LocationOption>
									<Divider sx={savedAddressDividerSX} />
								</>
							);
						})}
					</Box>
				</>
			) : (
				<>
					<Typography variant="bodySubText" sx={addAddressMsgSX}>
						{localization.Msgs.noSavedAddress.t()}
					</Typography>
					<Button variant="contained" sx={addAddressBtnSX} onClick={handleOpenAddAddressDrawer}>
						<Typography variant="bodyBaseline">{localization.addNewAddress.t()}</Typography>
					</Button>
				</>
			)}
		</Stack>
	);
};
